/**
 * Query keys for per-invoice linked work (FIN-D4, L-1263): the batched reads Collect rows and To Send
 * cards use. In their own file so every link/unlink mutation can invalidate them without an import
 * cycle through useInvoiceLinkedWork.
 */
export const linkedWorkKeys = {
  all: ['linkedWork'] as const,
  /** Every per-invoice link read: what a link change invalidates (project names are not touched). */
  forInvoiceAll: () => [...linkedWorkKeys.all, 'forInvoice'] as const,
  forInvoice: (organizationId: string, invoiceDocId: string) =>
    [...linkedWorkKeys.forInvoiceAll(), organizationId, invoiceDocId] as const,
  projectLabel: (projectId: string) => [...linkedWorkKeys.all, 'projectLabel', projectId] as const,
};
